/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { IoCloseSharp } from 'react-icons/io5';
import {
  resultCardId,
  hyphenate,
  workPackageStateCharacter
} from '../../utils/string';
import { openDetailCard } from '../../utils/sprintHelpers';
import VrsDropdown from '../PlanWall/vrsDropdown';
import SelectField from './selectField';
import Store from '../../store/store';

class UnfinishedResults extends React.Component {
  state = {
    selectedUnfinishedResults: [],
    targetIdSelected: -1
  };

  componentDidMount() {
    if (this.props.unfinishedResults.length > 0) {
      const selectedUnfinishedResults = this.props.unfinishedResults.map(
        (result) => result.id
      );
      this.setState({ selectedUnfinishedResults });
    }
    if (this.props.targets.length > 0) {
      this.setState({ targetIdSelected: this.props.targets[0].id });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.targets.length !== nextProps.targets.length) {
      if (nextProps.targets.length > 0) {
        this.setState({ targetIdSelected: nextProps.targets[0].id });
      } else {
        this.setState({ targetIdSelected: -1 });
      }
    }
  }

  onSelectTargetChange = (value) => {
    this.setState({ targetIdSelected: value });
  };

  handleResultSelect = (resultId) => {
    const { selectedUnfinishedResults } = this.state;
    const resultIndex = selectedUnfinishedResults.findIndex(
      (id) => id === resultId
    );
    if (resultIndex > -1) {
      const newUnfinishedResults = selectedUnfinishedResults.filter(
        (id) => id !== resultId
      );
      this.setState({ selectedUnfinishedResults: newUnfinishedResults });
    } else {
      selectedUnfinishedResults.push(resultId);
      this.setState({ selectedUnfinishedResults });
    }
  };

  continue = () => {
    const { type, currentTarget, sprint, onClose, endGroup } = this.props;
    const { selectedUnfinishedResults } = this.state;

    if (type === 'target') {
      const { targetIdSelected } = this.state;
      const { targetStatus } = this.props;

      endGroup(
        selectedUnfinishedResults,
        targetIdSelected,
        currentTarget,
        targetStatus
      );
      onClose();
    } else endGroup(selectedUnfinishedResults, sprint, onClose);
  };

  renderVRS = (result) => {
    // this looks good for end of sprint modal
    // reeds refactoring for end of target modal - if its going to be a thing

    const { result_type, level } = result;
    const { type_attributes } = result_type;
    const { defaultOptions } = Store.getState().defaultOptionsReducer;

    let valueSquare;
    let valueDefaults;
    if (result_type.kind !== 'Defect') {
      valueDefaults = defaultOptions.value_defaults;
      valueSquare = (
        <VrsDropdown
          key={`value-${result.id}`}
          type="value"
          level={level}
          data={type_attributes}
          options={valueDefaults.values}
          disabled
          resultType={result_type}
        />
      );
    } else {
      valueDefaults = defaultOptions.severity_defaults;
      valueSquare = (
        <VrsDropdown
          key={`value-${result.id}`}
          type="value"
          level={level}
          data={type_attributes}
          options={valueDefaults.values}
          disabled
          resultType={result_type}
        />
      );
    }

    const riskDefaults = defaultOptions.risk_defaults;
    const sizeDefaults = defaultOptions.size_defaults;

    const riskSquare = (
      <VrsDropdown
        key={`risk-${result.id}`}
        type="risk"
        level={level}
        data={type_attributes}
        options={riskDefaults.values}
        disabled
        resultType={result_type}
      />
    );

    const sizeSquare = (
      <VrsDropdown
        key={`size-${result.id}`}
        type="size"
        level={level}
        data={type_attributes}
        options={sizeDefaults.values}
        disabled
        resultType={result_type}
      />
    );

    const sprintResultVRS = [valueSquare, riskSquare, sizeSquare];

    return <div className="sprint-result-vrs">{sprintResultVRS}</div>;
  };

  render() {
    const {
      unfinishedResults,
      onClose,
      isOpen,
      title,
      type,
      targets
    } = this.props;

    const { targetIdSelected } = this.state;

    const selectedTarget = targets.find((t) => t.id === targetIdSelected);

    let selectedTargetOption;

    if (selectedTarget) {
      selectedTargetOption = {
        label: selectedTarget.short_name,
        value: targetIdSelected
      };
    } else {
      selectedTargetOption = { label: null, value: null };
    }

    let targetOptions;

    if (type === 'target') {
      targetOptions = targets.map((target) => ({
        label: target.short_name,
        value: target.id
      }));
    }

    return (
      isOpen && (
        <div
          className="detail-modal unfinished-results-modal"
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="ur-modal-header">
                <div className="ur-modal-header-title">{title}</div>
                <div>
                  <button type="button" className="btn-close" onClick={onClose}>
                    <IoCloseSharp size="2em" />
                  </button>
                </div>
              </div>
              <div className="modal-body">
                {type === 'target' && targetOptions.length > 0 && (
                  <form className="form-inline target-options">
                    <SelectField
                      value={selectedTargetOption}
                      label="Select a Target"
                      handleChange={this.onSelectTargetChange}
                      options={targetOptions}
                      allowEdit
                    />
                  </form>
                )}
                <div className={`all-results ${type}`}>
                  {unfinishedResults.map((workPackage) => {
                    const isChecked = this.state.selectedUnfinishedResults.findIndex(
                      (id) => id === workPackage.id
                    );
                    return (
                      <div
                        key={workPackage.id}
                        className="unfinished-results-list"
                      >
                        <div className="ur-check-and-title">
                          <div className="ur-label-checkbox">
                            <label className="ur-checkbox-container">
                              <input
                                id={workPackage.id}
                                type="checkbox"
                                checked={isChecked > -1}
                                onChange={() =>
                                  this.handleResultSelect(workPackage.id)
                                }
                              />
                              <span className="custom-checkmark" />
                            </label>
                            <a onClick={() => openDetailCard(workPackage)}>
                              {workPackage.result_type
                                ? resultCardId(workPackage)
                                : `O${workPackage.id}`}
                            </a>
                          </div>
                          <div
                            className="feature-name"
                            style={{ paddingLeft: '3px' }}
                          >
                            {workPackage.name}
                          </div>
                        </div>
                        <div
                          className="right ur-vrs-state"
                          style={{ marginLeft: 'auto', paddingRight: '3px' }}
                        >
                          {this.renderVRS(workPackage)}

                          <span
                            className={`icon ur-state ${hyphenate(
                              workPackage.state || ''
                            )}`}
                          >
                            {workPackageStateCharacter(workPackage)}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-default ur-cancel"
                  onClick={onClose}
                >
                  CANCEL
                </button>
                <button
                  type="button"
                  className="btn btn-primary ur-continue"
                  onClick={this.continue}
                >
                  CONTINUE
                </button>
              </div>
            </div>
          </div>
        </div>
      )
    );
  }
}

UnfinishedResults.propTypes = {
  unfinishedResults: PropTypes.array,
  title: PropTypes.string,
  type: PropTypes.string,
  targets: PropTypes.array,
  currentTarget: PropTypes.object,
  onClose: PropTypes.func,
  endGroup: PropTypes.func
};

UnfinishedResults.defaultProps = {
  unfinishedResults: [],
  targets: [],
  currentTarget: {},
  title: 'The following stories will be carried over to the next sprint.',
  type: 'sprint'
};

export default UnfinishedResults;
